import LegalPage from './LegalPage';
import { fetchRefundPolicy } from '../lib/api';

const RefundPolicy = () => (
  <LegalPage
    pageKey="refund"
    fallbackTitle="Refund Policy"
    fetcher={fetchRefundPolicy}
    description="Read EatMeat's Refund Policy to understand our refund terms and how to request a refund."
    icon="💸"
    accentColor="text-green-600 bg-green-50 border-green-100"
  />
);

export default RefundPolicy;
